// Copyright (c) Docugami, Inc. All rights reserved.

import { LoggerLevel } from "utils/Logger";

// If you want to develop against the local auth or frontend microservice,
// replace the staging urls with the localhost url for the respective service.

export const dev = {
    baseUrl: "https://localhost:3000",
    auth0: {
        // Try "dev-docugami.us.auth0.com" if the custom domain doesn't work.
        domain: "auth-staging.docugami.com",
        clientId: "fWAo32h0lT4XDQEWqlSPR0oeUfGGcyz9",
        audience: "https://api-staging.docugami.com/",
        scope: "openid profile email offline_access read:workspace write:workspace read:documents write:documents read:builds write:builds read:projects write:projects read:samples"
    },
    signupUrl: "https://www.docugami.com/vip-early-access",
    // apiUrl: "http://localhost:5000",
    apiUrl: "https://api-staging.docugami.com/frontend",
    // dgmlUrl: "http://localhost:5002",
    dgmlUrl: "https://api-staging.docugami.com",
    // workspaceApiUrl: "http://localhost:5000/workspace",
    workspaceApiUrl: "https://api-staging.docugami.com/workspace",
    // projectsApiUrl: "http://localhost:5000/projects",
    projectsApiUrl: "https://api-staging.docugami.com/projects",
    // reportsApiUrl: "http://localhost:7092/reports",
    reportsApiUrl: "https://api-staging.docugami.com/reports",
    // exportApiUrl: "http://localhost:5000/export",
    exportApiUrl: "https://api-staging.docugami.com/export",
    // importApiUrl: "http://localhost:5000/import",
    importApiUrl: "https://api-staging.docugami.com/import",
    // filesApiUrl: "http:/localhost:5000/files",
    filesApiUrl: "https://api-staging.docugami.com/files",
    // downloadApiUrl: "http:/localhost:5000/download",
    downloadApiUrl: "https://api-staging.docugami.com/download",
    // fileManagerApiUrl: "http://localhost:7073/filemanager",
    fileManagerApiUrl: "https://api-staging.docugami.com/filemanager",
    // billingApiUrl: "http://localhost:5287/billing",
    billingApiUrl: "https://api-staging.docugami.com/billing",
    // chatUrl: "http://localhost:9000",
    chatUrl: "https://api-staging.docugami.com/chat-service",
    // repeatsUrl: "http://localhost:5015/repeats",
    repeatsUrl: "https://api-staging.docugami.com/repeats",
    //storageUrl: "http://localhost:5000/storage",
    storageUrl: "https://api-staging.docugami.com/storage",
    contactUsUrl: "https://www.docugami.com/contact-us?hsLang=en",
    dropboxAppKey: "8lnc0py8tcvznq5",
    verboseReduxLogging: true,
    sdvDevMode: true,
    devAlias: "",
    workPaths: {
        saveIntervalMs: 30000
    },
    logger: {
        Default: LoggerLevel.Information
    },
    featureFlags: {
        DiagnosticLoggingEnabled: true,
    },
    appInsights: {
        connectionString: "InstrumentationKey=e7b3f7e0-c4ea-4215-af98-301685691a8d;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=75120975-43c1-49f2-8d6e-344e91ae34d8",
        instrumentationKey: "e7b3f7e0-c4ea-4215-af98-301685691a8d",
        correlationHeaderDomains: ["localhost", "api-staging.docugami.com"]
    },
    idleTimeoutInMinutes: 55,
    idlePromptTimeoutInMinutes: 5,
    chameleonKey: "SNxrr2KpmZBPREpW1M7tgCRj5fqJqdKKoj3CTgt7wHS8XP-1ODfaG-DVwVP6wOpLcLMqRx",
    userbackKey: "8995|16473|qt0e3gwYZvSpoQFvGzpJFqzKdx3FmYNPjoVvMtTc9w6Yx6B8Du",
    googleAnalyticsKey: "G-EMVSHJD3T2",
    apiDocumentationUrl: "https://api-docs-staging.docugami.com",

    // publicApiBaseUrl: "http://localhost:5000/v1preview1",
    publicApiBaseUrl: "https://api-staging.docugami.com/v1preview1"
}

export const staging = {
    baseUrl: "https://app-staging.docugami.com",
    auth0: {
        // Try "dev-docugami.us.auth0.com" if the custom domain doesn't work.
        domain: "auth-staging.docugami.com",
        clientId: "fWAo32h0lT4XDQEWqlSPR0oeUfGGcyz9",
        audience: "https://api-staging.docugami.com/",
        scope: "openid profile email offline_access read:workspace write:workspace read:documents write:documents read:builds write:builds read:projects write:projects read:samples"
    },
    signupUrl: "https://www.docugami.com/vip-early-access",
    apiUrl: "https://api-staging.docugami.com/frontend",
    dgmlUrl: "https://api-staging.docugami.com",
    organizationApiUrl: "https://api-staging.docugami.com/organization",
    workspaceApiUrl: "https://api-staging.docugami.com/workspace",
    projectsApiUrl: "https://api-staging.docugami.com/projects",
    reportsApiUrl: "https://api-staging.docugami.com/reports",
    exportApiUrl: "https://api-staging.docugami.com/export",
    importApiUrl: "https://api-staging.docugami.com/import",
    filesApiUrl: "https://api-staging.docugami.com/files",
    downloadApiUrl: "https://api-staging.docugami.com/download",
    fileManagerApiUrl: "https://api-staging.docugami.com/filemanager",
    billingApiUrl: "https://api-staging.docugami.com/billing",
    chatUrl: "https://api-staging.docugami.com/chat-service",
    repeatsUrl: "https://api-staging.docugami.com/repeats",
    storageUrl: "https://api-staging.docugami.com/storage",
    contactUsUrl: "https://www.docugami.com/contact-us?hsLang=en",
    dropboxAppKey: "8lnc0py8tcvznq5",
    verboseReduxLogging: true,
    sdvDevMode: false,
    devAlias: "",
    workPaths: {
        saveIntervalMs: 30000
    },
    logger: {
        Default: LoggerLevel.Warning
    },
    featureFlags: {
        DiagnosticLoggingEnabled: true,
    },
    appInsights: {
        connectionString: "",
        instrumentationKey: "",
        correlationHeaderDomains: ["api-staging.docugami.com"]
    },
    idleTimeoutInMinutes: 700,
    idlePromptTimeoutInMinutes: 20,
    chameleonKey: "SNxrr2KpmZBPREpW1M7tgCRj5fqJqdKKoj3CTgt7wHS8XP-1ODfaG-DVwVP6wOpLcLMqRx",
    userbackKey: "8995|16473|qt0e3gwYZvSpoQFvGzpJFqzKdx3FmYNPjoVvMtTc9w6Yx6B8Du",
    googleAnalyticsKey: "G-EMVSHJD3T2",
    apiDocumentationUrl: "https://api-docs-staging.docugami.com",

    publicApiBaseUrl: "https://api-staging.docugami.com/v1preview1"
}

export const prod = {
    baseUrl: "https://app.docugami.com",
    auth0: {
        // Try "docugami.us.auth0.com" if the custom domain doesn't work.
        domain: "auth.docugami.com",
        clientId: "ed6uEeoc3DmbJfDku70h0n2nT4H0zIhN",
        audience: "https://api.docugami.com/",
        scope: "openid profile email offline_access read:workspace write:workspace read:documents write:documents read:builds write:builds read:projects write:projects read:samples"
    },
    signupUrl: "https://www.docugami.com/vip-early-access",
    apiUrl: "https://api.docugami.com/frontend",
    dgmlUrl: "https://api.docugami.com",
    organizationApiUrl: "https://api.docugami.com/organization",
    workspaceApiUrl: "https://api.docugami.com/workspace",
    projectsApiUrl: "https://api.docugami.com/projects",
    reportsApiUrl: "https://api.docugami.com/reports",
    exportApiUrl: "https://api.docugami.com/export",
    importApiUrl: "https://api.docugami.com/import",
    filesApiUrl: "https://api.docugami.com/files",
    downloadApiUrl: "https://api.docugami.com/download",
    fileManagerApiUrl: "https://api.docugami.com/filemanager",
    billingApiUrl: "https://api.docugami.com/billing",
    chatUrl: "https://api.docugami.com/chat-service",
    repeatsUrl: "https://api.docugami.com/repeats",
    storageUrl: "https://api.docugami.com/storage",
    contactUsUrl: "https://www.docugami.com/contact-us?hsLang=en",
    dropboxAppKey: "32lp25ltf8ee8pj",
    verboseReduxLogging: false,
    sdvDevMode: false,
    devAlias: "",
    workPaths: {
        saveIntervalMs: 30000
    },
    logger: {
        Default: LoggerLevel.Error
    },
    featureFlags: {
    },
    appInsights: {
        connectionString: "",
        instrumentationKey: "",
        correlationHeaderDomains: ["api.docugami.com"]
    },
    idleTimeoutInMinutes: 700,
    idlePromptTimeoutInMinutes: 20,
    chameleonKey: "SNxrr2KpmZBPREpW1M7tgCRj5fqJqdKKoj3CTgt7wHS8XP-1ODfaG-DVwVP6wOpLcLMqRx",
    userbackKey: "8995|16599|qt0e3gwYZvSpoQFvGzpJFqzKdx3FmYNPjoVvMtTc9w6Yx6B8Du",
    googleAnalyticsKey: "G-RRBDQPP02V",
    apiDocumentationUrl: "https://api-docs.docugami.com",

    publicApiBaseUrl: "https://api.docugami.com/v1preview1"
}

// Production dev: localhost frontend with production backends via proxy
// Use this to test against production data locally
// IMPORTANT: Run the proxy first: node proxy-to-prod.js
// Then get a production token and inject it into localhost localStorage
export const prodDev = {
    ...prod,
    baseUrl: "https://localhost:3000",
    // Point all API URLs to the local proxy (which forwards to production)
    apiUrl: "http://localhost:8888/frontend",
    dgmlUrl: "http://localhost:8888",
    organizationApiUrl: "http://localhost:8888/organization",
    workspaceApiUrl: "http://localhost:8888/workspace",
    projectsApiUrl: "http://localhost:8888/projects",
    reportsApiUrl: "http://localhost:8888/reports",
    exportApiUrl: "http://localhost:8888/export",
    importApiUrl: "http://localhost:8888/import",
    filesApiUrl: "http://localhost:8888/files",
    downloadApiUrl: "http://localhost:8888/download",
    fileManagerApiUrl: "http://localhost:8888/filemanager",
    billingApiUrl: "http://localhost:8888/billing",
    chatUrl: "http://localhost:8888/chat-service",
    repeatsUrl: "http://localhost:8888/repeats",
    storageUrl: "http://localhost:8888/storage",
    publicApiBaseUrl: "http://localhost:8888/v1preview1",
    verboseReduxLogging: true,
    sdvDevMode: true,
    logger: {
        Default: LoggerLevel.Information
    },
    featureFlags: {
        DiagnosticLoggingEnabled: true,
    },
    appInsights: {
        connectionString: "InstrumentationKey=e7b3f7e0-c4ea-4215-af98-301685691a8d;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=75120975-43c1-49f2-8d6e-344e91ae34d8",
        instrumentationKey: "e7b3f7e0-c4ea-4215-af98-301685691a8d",
        correlationHeaderDomains: ["localhost"]
    }
}

export const Config = process.env.REACT_APP_ENV === "prod" ? prod : process.env.REACT_APP_ENV === "proddev" ? prodDev : process.env.REACT_APP_ENV === "staging" ? staging : dev;

// Debug helper - logs the active config on startup
if (process.env.NODE_ENV === 'development') {
    console.log('🔧 Active Config:', process.env.REACT_APP_ENV || 'dev (default)');
    console.log('   Auth Domain:', Config.auth0.domain);
    console.log('   API URL:', Config.apiUrl);
    console.log('   Base URL:', Config.baseUrl);
}
